import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/components/Alert.css';

/**
 * Reusable alert component for success/error messages
 * @param {Object} props
 * @param {string} props.type - Alert type ('success', 'danger')
 * @param {string} props.message - Alert message
 * @param {Function} [props.onClose] - Optional close callback
 */
function Alert({ type, message, onClose }) {
  return (
    <div
      className={`alert alert-${type} alert-dismissible fade show animate__animated animate__fadeIn`}
      role="alert"
    >
      {message}
      {onClose && (
        <button
          type="button"
          className="btn-close"
          onClick={onClose}
          aria-label="Close"
        ></button>
      )}
    </div>
  );
}

Alert.propTypes = {
  type: PropTypes.oneOf(['success', 'danger', 'info', 'warning']).isRequired,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func,
};

export default Alert;